import { Datagrid, List, Loading, TextField, useGetList, useLocaleState } from 'react-admin';

export const DestinationPageList = () => {
  const list = useGetList('destinationpages', {
    sort: { field: 'updatedAt', order: 'DESC' },
  });
  const [locale] = useLocaleState();

  if (list.isLoading) {
    return <Loading></Loading>;
  }

  return (
    <List resource="destinationpages" sort={{ field: 'updatedAt', order: 'DESC' }}>
      <Datagrid rowClick="edit">
        <TextField source={`title.${locale}`} label="resources.destinationpages.fields.title" />
        <TextField source="updatedAt" label="resources.destinationpages.fields.updatedAt" />
      </Datagrid>
    </List>
  );
};
